module.exports = __webpack_public_path__ + "static/media/icon-info.f8de2f67.svg";